import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

const Button = ({ anchor, icon, iconLeft, onClickFnc, styles }) => {
  return (
      <div className={`relative max-h-46px px-4 py-15px font-semibold border border-black border-solid transition ease-in-out duration-300 stroke-black hover:cursor-pointer hover:bg-brand hover:border-brand hover:text-white hover:stroke-white ${icon ? 'pr-14' : ''} ${iconLeft ? 'pl-14' : ''} ${styles}`} onClick={onClickFnc} >
        {iconLeft &&
            <Icon id={iconLeft} viewBox="0 0 32 32" width="32" height="32" clsWrap="absolute top-1/2 left-4 transform -translate-y-1/2" />
        }
        {anchor}
        {icon &&
            <Icon id={icon} viewBox="0 0 32 32" width="32" height="32" clsWrap={`absolute top-1/2 right-4 transform -translate-y-1/2 ${icon === 'logout' ? 'top-26px -translate-y-0' : ''}`} />
        }
      </div>
  )
}

Button.defaultProps = {
  anchor: '',
  icon: false,
  iconLeft: false,
  styles: ''
}

Button.propTypes = {
  anchor: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  iconLeft: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onClickFnc: PropTypes.func,
  styles: PropTypes.string,
}


export default Button;